import { EventSubscription } from './event-subscription.interface';

/**
 * Delegate description for subscription removal proxying
 */
export type RemoveSubscriptionDelegate<TEmission> = (subscription: EventSubscription<TEmission>) => void;
